import React, { useContext, useState } from "react";
import { login as loginRequest } from "../../services/AuthServices";
import AuthContext from "../../context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import styles from './styles/LoginRegister.module.css';
import GoogleSignInButton from './GoogleSignInButton';
import TurnstileWidget from './TurnstileWidget';
import HoneypotField from './HoneypotField';

function Login({ setShowModal, setAuthModalState, acceptInvite, setAcceptInvite }) {
    const [userIdentifier, setUserIdentifier] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [website, setWebsite] = useState(""); // honeypot; stays empty for humans
    // The server asks for a CAPTCHA only when a login looks risky; until then
    // the widget stays hidden.
    const [captchaRequired, setCaptchaRequired] = useState(false);
    const [captchaToken, setCaptchaToken] = useState(null);
    const [captchaResetKey, setCaptchaResetKey] = useState(0);
    const { getLoggedIn } = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();

    const login = async (e) => {
        e.preventDefault();
        setErrorMessage("");
        try {
            await loginRequest({
                userIdentifier: userIdentifier.trim(),
                password,
                website,
                captchaToken: captchaToken || undefined,
            });

            await getLoggedIn();
            setShowModal(false);
            setAcceptInvite(false);
            if (acceptInvite && location.state?.token && location.state?.classroomId) {
                navigate(`/my-classrooms/${location.state.classroomId}/d`, { replace: true, state: { showModal: false } });

            } else {
                navigate("/home", { replace: true, state: { showModal: false } });
            }
        } catch (error) {
            if (error.response?.data?.captchaRequired) setCaptchaRequired(true);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                setErrorMessage(error.response.data.errorMessage);
            } else {
                setErrorMessage("An error occurred during login.");
                console.error(error);
            }
        } finally {
            // Turnstile tokens are single-use; fetch a fresh one for the next attempt.
            if (captchaToken) setCaptchaResetKey((key) => key + 1);
        }
    };

    const handleClickForgotPassword = () => {
        setErrorMessage("");
        setAuthModalState('forgot password');
    };

    const handleClickSignUpHere = () => {
        setErrorMessage("");
        setAuthModalState('sign up');
    };

    const handleClickContinueAsGuest = () => {
        setShowModal(false);
    };

    return (
        <div className={styles.container}>
            <img />
            <h1 className={styles.h1}>Login to AlphaScenario</h1>

            {/* Google Sign-In Button */}
            <GoogleSignInButton
                setErrorMessage={setErrorMessage}
                setShowModal={setShowModal}
                setAcceptInvite={setAcceptInvite}
                acceptInvite={acceptInvite}
            />

            {/* Divider */}
            <div className={styles.divider}>
                <span>OR</span>
            </div>

            {/* Existing Email/Password Form */}
            <form onSubmit={login} className={styles.form}>
                 {/* ... input fields ... */}
                <input
                    placeholder="Username or Email"
                    onChange={(e) => setUserIdentifier(e.target.value)}
                    value={userIdentifier}
                    className={styles.input}
                />
                <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    onChange={(e) => setPassword(e.target.value)}
                    value={password}
                    className={styles.input}
                />
                <label className={styles.showPassword}>
                    <input
                        type="checkbox"
                        checked={showPassword}
                        onChange={(e) => setShowPassword(e.target.checked)}
                        className={styles.checkbox}
                    />
                    Show Password
                </label>
                <HoneypotField value={website} onChange={setWebsite} />
                {captchaRequired && <TurnstileWidget onToken={setCaptchaToken} resetKey={captchaResetKey} />}
                {errorMessage && <div className={styles.error}> {errorMessage} </div>}
                <div className={styles.forgotPassword}><span className={styles.linkSpan} onClick={handleClickForgotPassword}>Forgot Password?</span></div>
                <button className={styles.button} type="submit">LOGIN</button>
            </form>
            <div className={styles.links}>
                Don't have an account? <span className={styles.linkSpan} onClick={handleClickSignUpHere}>Sign Up Here</span>
                {/* {!acceptInvite && (
                    <>
                        <br />
                        <span className={styles.orText}>OR</span>
                        <br />
                        <span className={styles.linkSpan} onClick={handleClickContinueAsGuest}>Continue as a guest</span>
                    </>
                )} */}
            </div>
        </div>
    );
}

export default Login;